import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommentsService } from '../service/comments.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-free-publisher-info-dialog',
    templateUrl: './free-publisher-info-dialog.component.html',
    styleUrl: './free-publisher-info-dialog.component.css',
    standalone: false
})
export class FreePublisherInfoDialogComponent {

  currentLang = this.translate.currentLang() ?? 'en'
  link:string

  constructor(
    public dialogRef: MatDialogRef<FreePublisherInfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private commentsService: CommentsService,
    private translate: TranslateService
  ){
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    //console.log(this.currentLang)
    if (this.currentLang == "de"){
      this.link = "https://go.narravero.com/demo"
    } else {
      this.link = "https://go.narravero.com/en/demo"
    }
    
  }
  closeDialog(){
    this.dialogRef.close()
  }

  makeAppointment(){
    window.open(this.link, '_blank')
  }
    
}
